import React from 'react';
import { Box, HStack, Avatar, Text } from '@chakra-ui/react';
import { MentionUser } from 'src/features/Goals/hooks/useMentionInput';

type MentionDropdownProps = {
  users: MentionUser[];
  onSelect: (user: MentionUser) => void;
  maxHeight?: string;
};

export const MentionDropdown: React.FC<MentionDropdownProps> = ({
  users,
  onSelect,
  maxHeight = '150px',
}) => {
  if (users.length === 0) return null;

  return (
    <Box
      position="absolute"
      bottom="100%"
      left={0}
      right={0}
      mb={1}
      bg="surface.card"
      borderRadius="md"
      boxShadow="lg"
      border="1px solid"
      borderColor="border.layout"
      maxH={maxHeight}
      overflowY="auto"
      zIndex={10}>
      {users.map((user) => (
        <HStack
          key={user.id}
          p={2}
          cursor="pointer"
          _hover={{ bg: 'surface.hover' }}
          onClick={() => onSelect(user)}>
          <Avatar size="sm" name={user.name} src={user.avatarUrl} />
          <Text fontSize="sm">{user.name}</Text>
        </HStack>
      ))}
    </Box>
  );
};
